import React from "react";
import { connect } from 'react-redux';
import { Route, Switch, Link } from 'react-router-dom';
import Application from './components/application/component';
import Registration from './components/registration/component';
import Login from './components/global/login-router-component';
import Logout from './components/global/logout-component';
import ResetPassword from './components/global/reset-password-component';
import Listing from './components/listings/route-table';
import User from './components/user/component';
import Dashboard from './components/dashboard/component';
import Search from './components/search/component';
import FeaturedListingComponent from './components/listings/featured-listings-component';
import Admin from './components/admin/route-table';
import VerifyEmailLogin from './components/registration/forms/generic/verifyEmailLogin';

//Datepicker initialization
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { PAGE_ROUTES } from "./constants/pageRoutes";

const mapStateToProps = state => ({
  impersonating: state.Global.impersonating,
  user: state.Dashboard.user
});

// app component
export const Routes = connect(mapStateToProps)((props) => {
  return (
    <div className="app-container">
      {props.impersonating && props.user && (
        <div className='row impersonation mb-3'>
          <div className='ml-auto mr-auto mt-2'>
            <h3>
              <i className="fas fa-user-secret mr-2"></i>
              You are impersonating {props.user.firstName.toUpperCase()}
              {props.user.lastName.substr(0, 1).toUpperCase()}.
            </h3>
          </div>
          <div className='impersonation-link'>
            <Link to={PAGE_ROUTES.LOGOUT}>
              Sign Out
              <i className="fas fa-sign-out-alt"></i>
            </Link>
          </div>
        </div>
      )}
      <Switch>
        <Route path={PAGE_ROUTES.CREATE_ACCOUNT} component={Registration} />
        <Route path={PAGE_ROUTES.LOGIN} component={Login} />
        <Route path={PAGE_ROUTES.LOGOUT} component={Logout} />
        <Route path={PAGE_ROUTES.RESET_PASSWORD} component={ResetPassword} />
        <Route path={PAGE_ROUTES.PROFILE} component={User} />
        <Route exact path={PAGE_ROUTES.APPLICATION} component={Application} />
        <Route path={PAGE_ROUTES.DASHBOARD} component={Dashboard} />
        <Route path={PAGE_ROUTES.LISTING} component={Listing} />
        <Route path={PAGE_ROUTES.SEARCH} component={Search} />
        <Route path={PAGE_ROUTES.VERIFY_EMAIL} component={VerifyEmailLogin} />
        {/* this route can and should be removed once implemented in WordPress */}
        <Route path={PAGE_ROUTES.FEATURED_LISTING} component={FeaturedListingComponent} />
        <Route path={PAGE_ROUTES.ADMIN} component={Admin} />
      </Switch>
    </div>
  )
})
